export default {
    API_BASE: 'https://d36u5buucu9rtz.cloudfront.net/api/mobileKlinik/'
}